import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BasePage from "../../../Components/Base/BasePage";

const PainelPowerBIPage = (props: any) => {
	let location = useLocation();
	const [url, setUrl] = useState();

	useEffect(() => {
		if (location?.state?.url == null)
		{
			return;
		}

		setUrl(location.state.url);
	}, [location?.state?.url]);

	return (
		<BasePage>
			<iframe width="100%" height="99%" src={url}></iframe>
		</BasePage>
	);
}

export default PainelPowerBIPage;